<template>
  <div class="custom-script">
    <section class="script-agent__section mt-5">
      <div class="d-flex mb-5">
        <v-btn
          outlined
          color="error"
          @click="() => deleteCustomScript(script_id)"
        >
          <v-icon left> mdi-delete </v-icon>
          Delete
        </v-btn>
        <v-spacer />
        <v-btn outlined color="success" @click="onEditScript" v-if="!edit">
          <v-icon left> mdi-pencil </v-icon>
          Edit
        </v-btn>
        <v-btn outlined color="success" @click="onSaveChangeScript" v-else>
          <v-icon left> mdi-checkbox-marked-circle </v-icon>
          Save
        </v-btn>
      </div>
      <div class="output ql-bubble script-text" v-if="!edit">
        <div class="ql-editor" v-html="content"></div>
      </div>
      <quill-editor
        v-else
        v-model="content"
        ref="editScript"
        :options="editorOption"
      />
    </section>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "CustomScript",
  props: {
    script_id: Number,
    html: String,
    lead: Object,
  },
  data() {
    return {
      edit: false,
      content: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    ...mapMutations({
      deleteScript: "lead/DELETE_SCRIPT",
    }),
    deleteCustomScript(id) {
      this.$axios
        .delete(`/agents/scripts/${id}`)
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.deleteScript(id);
        })
        .catch((err) =>
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          })
        );
    },
    onEditScript() {
      this.edit = true;
    },
    onSaveChangeScript() {
      this.edit = false;
      this.$axios
        .patch(`/agents/scripts/${this.script_id}`, {
          html: this.content,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) =>
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          })
        );
    },
  },
  mounted() {
    this.content = this.html;
  },
};
</script>

<style lang="scss">
.custom-script {
  .btn-wrapper {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &_right {
      justify-content: flex-end;
    }
  }
}
</style>